import { Layout, Menu, Popconfirm } from 'antd'
import {
  HomeOutlined,
  DiffOutlined,
  LogoutOutlined,
  DeleteOutlined,
} from '@ant-design/icons'
import './index.scss'
import { Outlet, useLocation, useNavigate } from 'react-router-dom'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { clearUserInfo, fetchUserInfo } from '@/store/modules/user'

const { Header, Sider } = Layout

const items = [
  {
    label: '計算',
    key: '/',
    icon: <HomeOutlined />,
  },
  {
    label: 'ツアーリスト',
    key: '/tourupload',
    icon: <DiffOutlined />,
  },
  {
    label: '削除リスト',
    key: '/records',
    icon: <DeleteOutlined />,
  },
]

const GeekLayout = () => {
  const navigate = useNavigate()
  const onMenuClick = (route) => {
    const path = route.key
    navigate(path)
  }
  const location = useLocation()
  const selectedKey = location.pathname

  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(fetchUserInfo())
  }, [dispatch])

  const name  = useSelector(state => state.user.userInfo.name)
  // const userInfo  = useSelector(state => state.user.userInfo)
  // const name = userInfo ? userInfo.name : '未登录'; // 添加空值检查

  //   useEffect(() => {
  //   if (!name) {
  //     navigate('/login');
  //   }
  // }, [name, navigate]);

  const onConfirm = () => {
    dispatch(clearUserInfo())
    navigate('/login')
  }
  return (
    <Layout>
      <Header className="header">
        <div className="logo" />
        <div className="user-info">
          <span className="user-name">{name}</span>
          <span className="user-logout">
            <Popconfirm title="ログアウトしますか" okText="ログアウト" cancelText="キャンセル" onConfirm={onConfirm}>
              <LogoutOutlined /> ログアウト
            </Popconfirm>
          </span>
        </div>
      </Header>
      <Layout>
        <Sider collapsible width={200} className="site-layout-background">
          <Menu
            mode="inline"
            theme="dark"
            selectedKeys={selectedKey}
            items={items}
            onClick={onMenuClick}
            style={{ height: '100%', borderRight: 0 }}></Menu>
        </Sider>
        <Layout className="layout-content" style={{ padding: 20 }}>
          <Outlet />
        </Layout>
      </Layout>
    </Layout>
  )
}
export default GeekLayout